// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2RbPH","footer":"ModalInfo_footer__2Nczg"};